import { render, staticRenderFns } from "./MsgDialog.vue?vue&type=template&id=b239d0ce&scoped=true&"
import script from "./MsgDialog.vue?vue&type=script&lang=js&"
export * from "./MsgDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b239d0ce",
  null
  
)

export default component.exports